import React from 'react';
import { twMerge } from 'tailwind-merge';
import { LoadingBars } from '@components/LoadingBars/LoadingBars';

export const LoadingGIF = React.memo(function LoadingGIF({
  className,
  barClassName,
}: {
  className?: string;
  barClassName?: string;
}) {
  return (
    <div className={twMerge('flex h-40 w-full items-center justify-center md:mt-8', className)}>
      <LoadingBars height={undefined} barClassName={barClassName} />
    </div>
  );
});
